class CookiesConsent {
    constructor(lang) {
        this.$cookiesLinks = $('.cookie-link');

        this._setLang(lang);
        this._init();
        this._setJobs();

        if(this.$cookiesLinks.length) {
            this._bindCookiesLinks();
        }
    }

    _init() {
        tarteaucitron.init({
            "privacyUrl": "/protection-des-donnees-personnelles", /* Privacy policy url */

            "hashtag": "#tarteaucitron", /* Open the panel with this hashtag */
            "cookieName": "tarteaucitron", /* Cookie name */

            "orientation": "bottom", /* Banner position (top - bottom) */

            "groupServices": false, /* Group services by category */

            "showAlertSmall": false, /* Show the small banner on bottom right */
            "cookieslist": true, /* Show the cookie list */

            "closePopup": false, /* Show a close X on the banner */

            "showIcon": false, /* Show cookie icon to manage cookies */
            //"iconSrc": "", /* Optionnal: URL or base64 encoded image */
            "iconPosition": "BottomRight", /* BottomRight, BottomLeft, TopRight and TopLeft */

            "adblocker": false, /* Show a Warning if an adblocker is detected */

            "DenyAllCta" : true, /* Show the deny all button */
            "AcceptAllCta" : true, /* Show the accept all button when highPrivacy on */

            "highPrivacy": false, /* Disable auto consent */

            "handleBrowserDNTRequest": false, /* If Do Not Track == 1, disallow all */

            "removeCredit": true, /* Remove credit link */
            "moreInfoLink": false, /* Show more info link */

            "useExternalCss": false, /* If false, the tarteaucitron.css file will be loaded */
            "useExternalJs": false, /* If false, the tarteaucitron.js file will be loaded */

            //"cookieDomain": ".my-multisite-domaine.fr", /* Shared cookie for multisite */

            "readmoreLink": "/protection-des-donnees-personnelles" /* Change the default readmore link */
        });
    }

    _bindCookiesLinks() {
        this.$cookiesLinks.on('click', tarteaucitron.userInterface.openPanel);
    }

    _setLang(lang) {
        /* supported: fr, en, de, es, it, pt, pl, ru */
        window.tarteaucitronForceLanguage = lang;
    }

    _setJobs() {
        // Add Google Analytics job
        if(window.location.hostname == 'oxance.fr') {
            tarteaucitron.user.gtagUa = 'G-VEPX4EEGWZ';
            tarteaucitron.user.gtagMore = function () { /* add here your optionnal gtag() */ };
            (tarteaucitron.job = tarteaucitron.job || []).push('gtag');
        }
    }
}

export default CookiesConsent;
